<p
  class="title"
  mat-dialog-title>
  Do you want to save your changes?
</p>
<mat-dialog-content>
  <button
    mat-raised-button
    [mat-dialog-close]="true">
    Yes
  </button>
  <button
    mat-raised-button
    (click)="no()"
    class="no">
    No
  </button>
</mat-dialog-content>
